import page from './Policy.vue';
export default page;


// WEBPACK FOOTER //
// ./src/pages/privacy-policy/index.js